import { PRICING_CONFIGS } from "@shapr3d/frontend-lib";

import messages from "../../locales/messages";

type FormatMessage = (descriptor: { id: string; defaultMessage?: string }) => string;

export function getWebAppPricingConfigs(t: FormatMessage) {
  const m = messages.PricingCards;

  return {
    free: {
      ...PRICING_CONFIGS.free,
      planName: t(m.Free.PlanName),
      features: [
        {
          category: "",
          items: [
            { text: t(m.Free.Feature.UpTo2Projects) },
            { text: t(m.Free.Feature.Platforms) },
            { text: t(m.Free.Feature.CloudStorage) },
            { text: t(m.Free.Feature.ImportFormats) },
            { text: t(m.Free.Feature.ImportSolidworks) },
            { text: t(m.Free.Feature.ImportImages) },
            { text: t(m.Free.Feature.ExportFormats) },
            { text: t(m.Free.Feature.GenerativeRenders) },
            { text: t(m.Free.Feature.Support) },
          ],
        },
      ],
    },
    individual: {
      ...PRICING_CONFIGS.individual,
      planName: t(m.Individual.PlanName),
      tagline: t(m.Individual.Tagline),
      seatTypes: undefined,
      features: [
        {
          category: "",
          items: [
            { text: t(m.Individual.Feature.UpTo100Projects) },
            { text: t(m.Individual.Feature.VersionHistory) },
            { text: t(m.Individual.Feature.CentralizedCloudStorage) },
            { text: t(m.Free.Feature.ImportFormats) },
            { text: t(m.Free.Feature.ImportSolidworks) },
            { text: t(m.Free.Feature.ImportImages) },
            { text: t(m.Individual.Feature.ExportShapr3D) },
            { text: t(m.Individual.Feature.ExportHighQualityMeshes) },
            { text: t(m.Individual.Feature.ExportStepIges) },
            { text: t(m.Individual.Feature.ExportDxfGroup) },
            { text: t(m.Individual.Feature.ExportUsdGroup) },
            { text: t(m.Individual.Feature.GenerativeRenders) },
            { text: t(m.Individual.Feature.TechnicalDrawings) },
            { text: t(m.Individual.Feature.RealtimeRenders) },
            { text: t(m.Individual.Feature.AR) },
            { text: t(m.Individual.Feature.ShareLinks) },
            { text: t(m.Individual.Feature.Support) },
          ],
        },
      ],
    },
    studio: {
      ...PRICING_CONFIGS.studio,
      planName: t(m.Studio.PlanName),
      tagline: t(m.Studio.Tagline),
      priceSubline: t(m.Studio.PriceSubline),
      seatTypes: undefined,
      features: [
        {
          category: "",
          items: [
            { text: t(m.Studio.Feature.UnlimitedProjects) },
            { text: t(m.Studio.Feature.UnlimitedTeamspaces) },
            { text: t(m.Studio.Feature.VersionHistory) },
            { text: t(m.Studio.Feature.DataOwnership) },
            { text: t(m.Studio.Feature.CentralizedCloudStorage) },
            { text: t(m.Studio.Feature.ImportUsdcJt) },
            { text: t(m.Studio.Feature.ImportCadFormats) },
            { text: t(m.Studio.Feature.ImportImages) },
            { text: t(m.Studio.Feature.ExportJt) },
            { text: t(m.Studio.Feature.ExportXt) },
            { text: t(m.Studio.Feature.GenerativeRenders) },
            { text: t(m.Studio.Feature.MaterialLibraries) },
            { text: t(m.Studio.Feature.VisionPro) },
            { text: t(m.Studio.Feature.Support) },
          ],
        },
      ],
    },
    enterprise: {
      ...PRICING_CONFIGS.enterprise,
      planName: t(m.Enterprise.PlanName),
      tagline: t(m.Enterprise.Tagline),
      seatTypes: undefined,
      features: [
        {
          category: "",
          items: [
            { text: t(m.Enterprise.Feature.UnlimitedProjects), icon: "dot" as const },
            { text: t(m.Enterprise.Feature.UnlimitedTeamsTeamspaces), icon: "dot" as const },
            { text: t(m.Enterprise.Feature.VersionHistory), icon: "dot" as const },
            { text: t(m.Enterprise.Feature.DataOwnership), icon: "dot" as const },
            {
              text: t(m.Enterprise.Feature.DataStorage),
              icon: "dot" as const,
              subItems: [
                t(m.Enterprise.Feature.DataStorageSingleTenant),
                t(m.Enterprise.Feature.DataStoragePrivateCloud),
                t(m.Enterprise.Feature.DataStorageOnPremise),
                t(m.Enterprise.Feature.DataStorageCloudOff),
              ],
            },
            { text: t(m.Enterprise.Feature.ImportCustom), icon: "dot" as const },
            { text: t(m.Enterprise.Feature.ExportCustom), icon: "dot" as const },
            { text: t(m.Enterprise.Feature.GenerativeRenders), icon: "dot" as const },
            { text: t(m.Enterprise.Feature.VisionPro), icon: "dot" as const },
            { text: t(m.Enterprise.Feature.Onboarding), icon: "dot" as const },
            { text: t(m.Enterprise.Feature.SecurityCompliance), icon: "dot" as const },
          ],
        },
      ],
    },
  };
}
